<template>
	<svg :width="props.width || 21" :height="props.height || 21" class="icon">
		<use xlink:href="#___icon___infant-club"></use>
	</svg>
</template>

<script setup lang="ts">
// Props
const props = defineProps<{
	width?: number;
	height?: number;
}>();
</script>
